import React from 'react';
import { setupConnect } from '@webcontainer/api/connect';

// Module-level guard: StrictMode double-mounts would otherwise run
// setupConnect twice (two bridge iframes + duplicated message relays).
let connected = false;

/**
 * Handshake page for opening the dev preview in a separate tab.
 *
 * The WebContainer (and its Vite dev server) lives in the STUDIO tab. When the
 * preview URL is opened in a new tab, that tab pops open
 * `/webcontainer/connect/<id>` on our origin; `setupConnect()` relays the
 * MessagePorts between the preview tab and the container. Without this route
 * the SPA's catch-all redirected the popup to "/" and the preview never
 * connected.
 *
 * NOTE: this page must be served WITHOUT COOP headers (only /studio sends
 * them) so `window.opener` survives — setupConnect requires it.
 */
export const WebContainerConnect: React.FC = () => {
    const [error, setError] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (connected) return;
        connected = true;
        try {
            setupConnect();
        } catch (e: any) {
            setError(e?.message || 'Failed to connect the preview.');
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-900 text-slate-300 text-sm">
            {error ? <p className="max-w-sm text-center text-red-400">{error}</p> : <p>Menghubungkan preview…</p>}
        </div>
    );
};
